import React from 'react';

const AdminDashboardScreen = () => {
  return <div>AdminDashboardScreen</div>;
};

export default AdminDashboardScreen;
